import { AccountType, MetaData } from '@qid/core';
import { ScannedImage } from "../modules/ocr";
import { SID } from "../modules/sid";

export class ID extends MetaData {

  name: string;
  documentNumberMasked: string;
  documentNumberHash: string;
  account_id: string;
  accountType: AccountType;
  sid?: SID;
  approved: boolean;
  skip: boolean;
  verificationTime: any;
  key: string;
  schemaVersion: number;
  account: any;
  faceId: string;

  constructor(name = null, scannedImages: ScannedImage[] = []) {
    super();
    this.name = name;
  }

  static getMasterKeyString(scannedImages: ScannedImage[]) {
    let masterKeystring = scannedImages[0].keyString;
    if (scannedImages.length > 1 && scannedImages[1]) {
      masterKeystring += scannedImages[1].keyString;
    }
    return masterKeystring;
  }

}

